const Backdrop = ({ closeModal }) => (
  <div className="backdrop" onClick={closeModal}></div>
);

export default Backdrop;
